export const SET_MICRO_FRONTEND_ID =
  "shared/MicroFrontend/SET_MICRO_FRONTEND_ID";
